// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__3dxiI","info":"PatientInfo_info__28Xuj"};